import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { TrainingCourseSection } from 'app/_models/training/training-course-section.model';
import { TrainingSectionType } from 'app/_models/training/training-section-type';
import { CaptchaService } from 'app/_services/captcha.service';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingCertService } from 'app/_services/training-cert.service';
import { TrainingEnergiaOverrideService } from 'app/_services/training-energia-override.service';
import { TrainingService } from 'app/_services/training.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'training-section',
  templateUrl: './training-section.component.html',
})
export class TrainingSectionComponent implements OnInit {
  public workerUserCourseId: number;
  private sectionId: number;
  private routeRole: any;
  public backLink: string[];

  public selectedTrainingSection: TrainingCourseSection;
  private sectionLink = 'training';
  public userCourseType = 'worker';

  public TrainingSectionType = TrainingSectionType; // allow enum in template

  public energiaOverrideIsLoading = false;

  public canLeave = false;

  constructor(
    private trainingService: TrainingService,
    private notificationService: NotificationService,
    private trainingCertService: TrainingCertService,
    private trainingEnergiaOverrideService: TrainingEnergiaOverrideService,
    private activatedRoute: ActivatedRoute,
    private captchaService: CaptchaService,
    private router: Router,
    private globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.sectionId = parseInt(params.sectionId);
      this.activatedRoute.queryParams.subscribe(queryParams => {
        if (queryParams['type'] === 'contractor') {
          this.workerUserCourseId = parseInt(params['userCourseId'], 10);
          this.sectionLink = 'outage-acceptance';
          this.userCourseType = 'contractor'
        } else {
          this.workerUserCourseId = parseInt(params['workerUserCourseId'], 10);

        }
        this.backLink = ['/', this.routeRole, this.sectionLink, this.workerUserCourseId];
        this.setupPage();
        if(queryParams['view'] === 'review'){
          this.canLeave = true;
        }
      });
    });
  }

  private setupPage() {
    this.selectedTrainingSection = null; // first set to null, so children update to new object when going from section to section of same type
    this.trainingService.getTrainingCourseSectionForWorkerByIdAndSection(this.workerUserCourseId, this.sectionId).subscribe(trainingSection => {
      this.selectedTrainingSection = trainingSection;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load training data');
    });
  }

  public goToNextSection() {
    if (this.selectedTrainingSection.nextSectionId) {
      this.router.navigate([this.routeRole, this.sectionLink, this.workerUserCourseId, 'section', this.selectedTrainingSection.nextSectionId],
        { queryParams: { type: this.userCourseType }}
      );
    } else {
      // Venuts / GE Induction Sites
      this.trainingService.getTrainingCourseForWorkerById(this.workerUserCourseId).subscribe(trainingCourse => {
        if (this.trainingCertService.shouldSendCertificatePdf(trainingCourse.course.siteIds)) {
          return this.captchaService.generateCaptchaToken('inductionCertSubmit').then(token => {
            const today = new Date();
            const expiryDate = new Date(today);
            expiryDate.setMonth(today.getMonth() + trainingCourse.course.validForMonths);

            let certificateDetails = {
              workerName: this.globals.user.firstName + ' ' + this.globals.user.lastName,
              company: this.globals.contractor.name,
              inductionName: trainingCourse.course.trainingName,
              siteName: trainingCourse.course.sites[0],
              startDate: today,
              expiryDate: expiryDate,
            }

            return this.trainingCertService.submitPdfCert(trainingCourse.course.trainingId, token, certificateDetails, trainingCourse.course.siteIds[0]).subscribe(result => {
              this.notificationService.notify('success', 'Success', 'Training complete');
              this.router.navigate(['/' + this.routeRole + '/training']);
            });
          });
        } else if (this.trainingEnergiaOverrideService.isEnergiaMainInduction(trainingCourse.course.trainingId)) {
          this.energiaOverrideIsLoading = true;

          this.trainingEnergiaOverrideService.passAllConnectedEnergiaInductions(trainingCourse.workerId).subscribe((results) => {
            this.energiaOverrideIsLoading = false;
            this.notificationService.notify('success', 'Success', 'Training complete');
            this.router.navigate([this.routeRole, 'training']);

            Swal.fire('Success', 'Please note, All other Energia Site Inductions were marked as complete as well', 'success');
          }, error => {
            console.error(error);
            this.energiaOverrideIsLoading = false;
            this.notificationService.notify('success', 'Success', 'Training complete');
            this.router.navigate([this.routeRole, 'training']);
            Swal.fire('Warning', 'Please note, You have passed this course but there may have been a problem updating the other Energia Site Inductions', 'warning');
          });
        } else {

          this.notificationService.notify('success', 'Success',
            this.userCourseType === 'contractor' ? 'Acceptance Complete' : 'Training Complete');
          this.router.navigate([this.routeRole, this.sectionLink]);
        }
      }, error => {
        console.error(error);
        this.notificationService.notify('danger', 'Error', 'Could not load training data');
      });
    }
  }

  public onSubmitSection() {
    const body = {
      workerUserCourseId: this.workerUserCourseId,
      courseSectionId: this.selectedTrainingSection.courseSectionId,
    };

    this.trainingService.submitSectionComplete(body).subscribe(response => {
      this.notificationService.notify('success', 'Success', 'Section complete');
      this.canLeave = true;
      this.goToNextSection();
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not mark section as complete');
    });
  }
}
